import { Navigate, useLocation } from "react-router-dom";
import { PROFILE_COMPLETION_PATH, withLocation } from "./navigationPaths";

export default function LegacyProfileRedirect() {
  const location = useLocation();
  return <Navigate to={withLocation(PROFILE_COMPLETION_PATH, location)} replace />;
}
